import { render, staticRenderFns } from "./invoice_component.vue?vue&type=template&id=94c576b4&scoped=true&"
import script from "../assets/js/invoice.js?vue&type=script&lang=js&"
export * from "../assets/js/invoice.js?vue&type=script&lang=js&"
import style0 from "./invoice_component.vue?vue&type=style&index=0&id=94c576b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c576b4",
  null
  
)

export default component.exports